import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "incident/:incidentId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "incident" */ "./components"),
      import(/* webpackChunkName: "incident" */ "./modules/IncidentModule"),
      import(
        /* webpackChunkName: "incident" */ "BehaviourManagement/modules/BehaviourModule"
      ),
    ]).then(([importedModule0, importedModule1, importedModule2]) => {
      const component = importedModule0.default;

      const incidentReducer = importedModule1.default;
      const incidentReducerName = importedModule1.NAME;

      const behaviourReducer = importedModule2.default;
      const behaviourReducerName = importedModule2.NAME;

      injectReducer(store, {
        key: incidentReducerName,
        reducer: incidentReducer,
      });

      injectReducer(store, {
        key: behaviourReducerName,
        reducer: behaviourReducer,
      });

      return component;
    })
  ),
  childRoutes: [],
});
